import EStyleSheet from "react-native-extended-stylesheet";

export const styles = EStyleSheet.create({
  popup: {
    width: 100,
    backgroundColor: "white",
    borderColor: "#eee",
    borderWidth: 1,
    borderRadius: 5,
    position: "absolute",
    top: 40,
    right: 40,
  },
  mediaOption: {
    padding: 5,
    flexDirection: "row",
    alignItems: "center",
    borderBottomWidth: 1,
    borderColor: "#eee",
  },
  mediaOptionText: {
    paddingLeft: 5,
  },
});
